

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import store from '@/store';
import { ALT_INFO_SITE, INFO_SITE } from '@/config';

type NAV_ITEM_TYPE = 'external_link' | 'link' | 'function';
interface INavItem {
  type: NAV_ITEM_TYPE;
  name: string;
  url?: string | (() => string);
  fn?: () => void;
  hide?: boolean;
}

@Component({
  data: () => ({
    INFO_SITE,
    ALT_INFO_SITE,
  }),
})
export default class Navbar extends Vue {
  public isActive = false;
  public hasConnectionIssues = false;

  get userItems(): INavItem[] {
    return [
      {
        type: 'external_link',
        name: 'Home',
        url: INFO_SITE,
      },
      {
        type: 'external_link',
        name: 'Game Rules',
        url: `${INFO_SITE}/rules`,
      },
      {
        type: 'link',
        name: 'Watch Game',
        url: '/selectGame?mode=watch',
      },
      {
        type: 'link',
        name: 'Sign Up',
        url: '/signup',
        hide: this.loggedIn,
      },
      {
        type: 'function',
        name: 'Play Game',
        fn: () => this.$router.push('/selectGame?mode=play'),
        hide: !this.loggedIn,
      },
      {
        type: 'link',
        name: 'Login to Play',
        url: '/login',
        hide: this.loggedIn,
      },
      {
        type: 'external_link',
        name: 'The Challenge',
        url: `${INFO_SITE}/contest`,
      },
      {
        type: 'link',
        name: 'Leader Board',
        url: `/leaderboard`,
      },
      {
        type: 'external_link',
        name: 'Contact',
        url: `${INFO_SITE}/contact`,
      },
      {
        type: 'link',
        name: 'My Account',
        url: '/account',
        hide: !this.loggedIn,
      },
    ];
  }

  get adminItems(): INavItem[] {
    return [
      { type: 'link', name: 'Play Game', url: '/selectGame?mode=watch' },
      { type: 'link', name: 'Manage Sessions', url: '/selectGame?mode=manage' },
      { type: 'link', name: 'Reporting', url: '/reports' },
    ];
  }

  @Prop({ required: false, type: Boolean, default: false })
  public adminMode!: boolean;

  public toggle() {
    this.isActive ? this.hide() : this.show();
  }
  public show() {
    this.isActive = true;
  }
  public hide() {
    this.isActive = false;
  }
  get loggedIn() {
    return store.getters['auth/authenticated'];
  }
  get navItems() {
    return (this.adminMode ? this.adminItems : this.userItems).filter(
      (item) => item && !item.hide,
    );
  }

  public itemLink(item: INavItem) {
    return typeof item.url === 'function' ? item.url() : item.url;
  }

  // public showSignUp() {
  //   this.showSignUpModal = true;
  //   return;
  // }

  // public showLogin() {
  //   this.showLoginModal = true;
  //   return;
  // }

  @Watch('$route')
  public onRouteChange() {
    this.hide();
  }
}
